import Component from 'component';
import VanillaModal from 'vanilla-modal';
import _template from 'lodash/template';

class VideoModal extends Component{
  constructor(el, config){
    super(el, config);

    this.modal = new VanillaModal({
      onBeforeClose: () => this.removeModalContent()
    });
  }

  setupDefaults() {
    this.dom = {
      $body: $('body'),
      $iframe: $('#wh-video-modal iframe'),
      modal: '#wh-video-modal'
    };

  }

  addListeners() {
    this.dom.$body.on('click', '.wh-video-trigger', this.onVideoTriggered.bind(this));
  }

  onVideoTriggered(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const videoId = $target.data('video-id');
    const accountId = $target.data('account-id');
    const playerId = $target.data('player-id');
    const hasVimeoVideo = $target.data('has-vimeo-video');
    const vimeoVideoUrl = $target.data('vimeo-video-url');
    const vimeoVideoThumbnaillUrl = $target.data('vimeo-video-thumbnail-url');

    if (!videoId) return;

    this.openModal({
      videoId,
      accountId,
      playerId,
      hasVimeoVideo,
      vimeoVideoUrl,
      vimeoVideoThumbnaillUrl
    });
  }

  openModal(data) {
    const tpl = _template(this.config.template)({
      data
    });

    this.dom.$body.append(tpl);

    this.modal.open(this.dom.modal);
    this.dom.$body.addClass('video-modal');

    // Modal Container
    const modalContainer = this.modal.dom.modal
    const focusableElements = modalContainer.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0];

    firstFocusableElement.focus();
  }

  removeModalContent() {
    this.dom.$body.removeClass('video-modal');
    $(this.dom.modal).remove();
  }
}


export default VideoModal;



// WEBPACK FOOTER //
// ./src/js/components/VideoModal.js